module.exports = __webpack_public_path__ + "img/node-js.76f43cfd.png";